/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = Sales.MaterialOutItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialOutJobWork extends _Ext.GridEditorBase<Sales.MaterialOutItemsRow> {


        protected getColumnsKey() { return "Sales.MaterialForJobWorkIssue"; }
        protected getDialogType() { return Sales.MaterialOutItemsDialog; }
        protected getLocalTextPrefix() { return Sales.MaterialOutItemsRow.localTextPrefix; }
        protected form: Sales.MaterialOutItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        // #region Variables
        public PartyId: number;
        public ProductId: number;
        public BOMProductIds: any[];
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        public ProductTypeId: number;
        public isUpdate: boolean;
        statement: string;
        public bagno: string;
        static LineNo: number;
        static Items: JobWork.JobWorkItemsRow;
        public closed: boolean;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            //var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            //Department.referencedFields = [fld.DepartmentId];
            //Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup());

            if (this.GenSKU == false) {
                Q.first(columns, x => x.field === fld.Pieces).format = int;
            }

            let itemtype = Q.first(columns, x => x.field === fld.Pieces);

            itemtype.format = ctx => {
                if (ctx.item.ItemTypeId == 105)
                    return ColumnFormatter.integerInputFormatter(ctx, this);
            }

            ///Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows(Item: any) {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        let values;

                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }

                    }

                    this.view.refresh();
                }
            }
        }

        public setData(Items: any[]) {
            //set data in Material Grid from Job Work
            //this.Items = Items;
            let BOMdetails;
            for (let item of Items) {
                BOMdetails = item.BOMDetails;
                for (var BOM of BOMdetails) {
                    var exists: boolean = false;
                    var PrdDetails: OMS.ProductMasterRow;
                    OMS.ProductMasterService.Retrieve({ EntityId: BOM.BOMProductId }, response => PrdDetails = response.Entity, { async: false });

                    if (PrdDetails.ItemTypeId != 104) {
                        var detail: Sales.MaterialOutItemsRow = {
                            AttributeId: BOM.BOMAttributeId,
                            ProductCode: BOM.ProductCode,
                            ProductId: BOM.BOMProductId,
                            DepartmentId: item.DepartmentId,
                            ProductName: BOM.ProductName,
                            SKU: item.SKU,
                            Line_No: item.Line_No,
                            Pieces: BOM.Pieces == null ? 0 : BOM.Pieces,
                            Weight: BOM.Weight,
                            HSN: item.HSN,
                            Attribute: PrdDetails.Attribute,
                            CalcOnId: BOM.CalcOnId,
                            Purity: PrdDetails.Purity
                        };
                        //  JobWork.JobWorkDialog.editorClosed = true;
                        var x = this.view.getItems();
                        x.forEach(function (value) {

                            if (value.Line_No == detail.Line_No && value.ProductId == BOM.BOMProductId)
                                exists = true;
                        });
                        if (exists == false) {
                            detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(detail);
                        }
                        else {
                            Q.notifyWarning("RM Already Issued!!");
                        }

                    }

                }
            }
        }

        public setBOMData(Items: any[], item: any) {
            //set data in Material Grid from Job Work
            //this.Items = Items;
            for (var BOM of Items) {
                var exists: boolean = false;
                var PrdDetails: OMS.ProductMasterRow;
                OMS.ProductMasterService.Retrieve({ EntityId: BOM.BOMProductId }, response => PrdDetails = response.Entity, { async: false })

                var DeptName = OMS.DepartmentMasterRow.getLookup().itemById[item.DepartmentId].DeptName
                if (PrdDetails.ItemTypeId != 104) {
                    var detail: Sales.MaterialOutItemsRow = {
                        AttributeId: BOM.AttributeId,
                        ProductCode: PrdDetails.ProductCode,
                        ProductId: BOM.ProductId,
                        DepartmentId: item.DepartmentId,
                        DeptName: DeptName,
                        ProductName: PrdDetails.ProductName,
                        SKU: item.SKU,
                        Line_No: item.Line_No,
                        Pieces: BOM.Pieces == null ? 0 : BOM.Pieces,
                        Weight: BOM.Weight,
                        HSN: item.HSN,
                        Attribute: PrdDetails.Attribute,
                        CalcOnId: BOM.CalcOnId,
                        Purity: PrdDetails.Purity == undefined ? 0 : PrdDetails.Purity
                    };

                    if (exists == false) {
                        detail[this.getIdProperty()] = "`" + this.nextId++;
                        this.view.addItem(detail);
                    }
                    else {
                        Q.notifyWarning("RM Already Issued!!");
                    }
                }


            }
            this.closed = true;
        }

        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Weight || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }
            var stockdata: Stock.StockItemRow;
            Stock.StockItemService.GetProductDetails({
                ProductId: item.ProductId,
                AttributeId: item.AttributeId,
                LotNo: item.LotNo
            }, function (response) {
                return stockdata = response.Entity;
            }, { async: false });
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (stockdata != null) {
                    if (value < stockdata.Pieces && item.Weight == stockdata.Weight) {
                        q.alert('Error', 'Invalid Pieces', true);
                        return;
                    }

                    else
                        item[field] = value;
                }

                if (item.CalcOnId == 3) {
                    if (stockdata != null && stockdata.Pieces >= value) {
                        item.GrossAmount = item.UnitRate * value;
                        item.NetAmount = item.UnitRate * value;

                        item[field] = value;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    } else {
                        Q.notifyError('Invalid Quantity', '', null);
                        input.val(oldText);
                        input.focus();
                        return;
                    }
                }
                else {
                    if (stockdata!= null && stockdata.Pieces >= value) {
                        //item.GrossAmount = item.UnitRate * value;
                        //item.NetAmount = item.UnitRate * value;

                        item[field] = value;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    } else {
                        Q.notifyError('Invalid Quantity', '', null);
                        input.val(oldText);
                        input.focus();
                        return;
                    }
                }
            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    if (stockdata!= null && stockdata.Weight >= value) {
                        item.GrossAmount = item.UnitRate * value;
                        item.NetAmount = item.UnitRate * value;
                        item.NetWeight = value;
                        item[field] = value;
                        this.view.updateItem(id, item);
                        this.view.refresh();
                    }
                } else {
                    Q.notifyError('Invalid Quantity', '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Stock.StockForMaterialSelectGrid;
            var lineno = 0;
            buttons.pop();
            // *** Add Select Button to Grid Editor ***
            //buttons.push({
            //    title: "Select Stone",
            //    cssClass: "add-button",
            //    hotkey: "Alt+K",
            //    onClick: () => {
            //        if (this.isUpdate) {
            //            Q.notifyWarning("Cannot Add Materials while Editing");
            //            return;

            //        }

            //        // **** Validate Party before Item Selection ****
            //        if (this.bagno == undefined || this.bagno == null) {
            //            Q.notifyWarning("Please Select Products to proceed");
            //            return;

            //        }
            //        else {
            //            var productids = [];
            //            var attributeids = [];
            //            let bomdetails; 
            //            WorkOrderforJWService.RefListforJobWorkList({ BagNo: this.bagno }
            //                , response => {
            //                    lineno = response.Entities[0].Line_No;
            //                    bomdetails = response.Entities[0].BOMDetails;

            //                }, { async: false });

            //            for (var i = 0; i < bomdetails.length; i++) {
            //                productids.push(bomdetails[i].BomProductId);
            //                attributeids.push(bomdetails[i].AttributeId);
            //                Stock.StockForMaterialSelectGrid.LineNo = lineno;
            //                lineno = lineno;
            //            }

            //            Stock.StockForMaterialSelectGrid.ItemType = 3;
            //            Stock.StockForMaterialSelectGrid.productIds = productids;
            //            Stock.StockForMaterialSelectGrid.attributeids = attributeids;
            //            var pickerDialog = new _Ext.GridItemPickerDialog({
            //                gridType: grid, multiple: true, title: "Select Items",
            //                preSelectedKeys: this.value.map(k => k.ProductId)
            //            });
            //        }

            //        pickerDialog.onSuccess = (selectedItems: any[]) => {
            //            let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId && n.AttributeId==t.AttributeId) });
            //            //alert('Length' + selectedItems.length);
            //            var self = this;
            //            var details = [];
            //            var genSKU = this.GenSKU;
            //            var companyId = Q.Authorization.userDefinition.CompanyId;

            //            // #region Items to Grid
            //            //for (let value of selectedItems2)
            //            selectedItems2.forEach(function (value: Stock.StockItemRow) {
            //                var PrdId = value.ProductId;
            //                var bomdetails = [];
            //                var labordetail = [];
            //                var PrdDetails = OMS.ProductMasterRow.getLookup().itemById[PrdId];


            //                // #region Product Attributes
            //                // **** Load & assign Attributes of Product using AtbID ****
            //                let ATBDetails = OMS.CommonAttributesRow.getLookup().itemById[value.AttributeId]
            //                var BaseItm = ATBDetails.ProductTypeId;
            //                var ItemTypeId = ATBDetails.ItemTypeId;
            //                var Type = ATBDetails.CategoryName;
            //                var CategoryId = ATBDetails.CategoryId;
            //                var SubType = ATBDetails.SubCategoryName;
            //                var SubCategoryId = ATBDetails.SubCategoryId;
            //                var Brand = ATBDetails.BrandName;
            //                var BrandId = ATBDetails.BrandId;
            //                var SuperType = ATBDetails.SuperTypeName;
            //                var SuperTypeId = ATBDetails.SuperTypeId;
            //                var Collection = ATBDetails.CollectionName;
            //                var CollectionId = ATBDetails.CollectionId;
            //                var CalcOn = PrdDetails.CalcOnId;

            //                // #region Rate, Tax , SKU & Labor 
            //                var Rate = 0;
            //                var LaborRate = 0;

            //                // **** Get SKU for Item ****
            //                if (genSKU == true) {
            //                    var SKU = FormatHelper.GetFormat("Sku", "HO");
            //                }

            //                // #endregion

            //                var MaterialOutitem: Sales.MaterialOutItemsRow = {
            //                    ProductId: PrdId,
            //                    AttributeId: value.AttributeId,
            //                    Line_No: lineno,
            //                    VoucherTypeId: value.VoucherTypeId,
            //                    PartyId: self.PartyId,
            //                    SKU: "0",
            //                    DepartmentId: value.DepartmentId,
            //                    DeptName: value.DeptName,
            //                    ProductCode: value.ProductCode,
            //                    ProductName: value.ProductName,
            //                    ItemTypeId: ItemTypeId,
            //                    CategoryId: CategoryId,
            //                    ProductTypeId: BaseItm,
            //                    ProductTypeName: ATBDetails.ProductTypeName,
            //                    SubCategoryId: SubCategoryId,
            //                    BrandId: BrandId,
            //                    SuperTypeId: SuperTypeId,
            //                    CollectionId: CollectionId,
            //                    UnitRate: Rate,
            //                    UnitLabour: LaborRate,
            //                    Pieces: value.Pieces,
            //                    Weight: value.Weight,
            //                    OtherPieces: value.OtherPieces,
            //                    OtherWeight: value.OtherWeight,
            //                    StonePieces: value.StonePieces,
            //                    StoneWeight: value.StoneWeight,
            //                    NetWeight: value.NetWeight,
            //                    NetAmount: (Rate + LaborRate) * 1,
            //                    GrossAmount: (Rate + LaborRate) * 1,
            //                    DiamondPieces: value.DiamondPieces,
            //                    DiamondWeight: value.DiamondWeight,
            //                    CalcOnId: CalcOn,
            //                    BOMDetails: bomdetails,
            //                    // LaborDetails: labordetail,
            //                    CompanyId: companyId,

            //                    HSN: value.HSN,
            //                    KaratId: ATBDetails.KaratId,
            //                    MetalColorId: ATBDetails.MetalColorId,
            //                    QualityId: ATBDetails.QualityId,
            //                    SieveId: ATBDetails.SieveId,
            //                    ShapeId: ATBDetails.ShapeId,
            //                    RefTransId: value.TransId,
            //                    StoneColorId: ATBDetails.StoneColorId,
            //                    StoneSizeId: ATBDetails.StoneSizeId,
            //                    Purity: value.Purity == undefined ? 0 : value.Purity,
            //                    TaxCode: value.TaxCode
            //                };
            //                details.push(MaterialOutitem);



            //            });
            //            for (let Detail of details) {
            //                Detail[this.getIdProperty()] = "`" + this.nextId++;
            //                this.view.addItem(Detail);
            //            }

            //        }
            //        // #endregion

            //        pickerDialog.dialogOpen();
            //    }
            //});
            //buttons.push({
            //    title: "Select Metal",
            //    cssClass: "add-button",
            //    hotkey: "Alt+K",
            //    onClick: () => {
            //        if (this.isUpdate) {
            //            Q.notifyWarning("Cannot Add Materials while Editing");
            //            return;

            //        }

            //        // **** Validate Party before Item Selection ****
            //        if (this.BOMProductIds == undefined || this.BOMProductIds == null) {
            //            Q.notifyWarning("Please Select Products to proceed");
            //            return;

            //        }
            //        else {
            //            var productids = [];
            //            var attributeids = [];
            //            var x = this.BOMProductIds; let bomdetails;
            //            WorkOrderforJWService.RefListforJobWorkList({ BagNo: this.bagno }
            //                , response => {
            //                    lineno = response.Entities[0].Line_No;
            //                    bomdetails = response.Entities[0].BOMDetails;

            //                }, { async: false });

            //            for (var i = 0; i < bomdetails.length; i++) {
            //                productids.push(bomdetails[i].BomProductId);
            //                attributeids.push(bomdetails[i].AttributeId); 
            //            }
                         
            //            Stock.StockForMaterialSelectGrid.ItemType = 4;
            //            Stock.StockForMaterialSelectGrid.productIds = productids;
                        
            //            var pickerDialog = new _Ext.GridItemPickerDialog({
            //                gridType: grid, multiple: true, title: "Select Items",
            //                preSelectedKeys: this.value.map(k => k.ProductId)
            //            });
            //        }

            //        pickerDialog.onSuccess = (selectedItems: any[]) => {
            //            let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
            //            //alert('Length' + selectedItems.length);
            //            var self = this;
            //            var details = [];
            //            var MaterialOutLabor = [];
            //            var genSKU = this.GenSKU;
            //            var companyId = Q.Authorization.userDefinition.CompanyId;

            //            // #region Items to Grid
            //            //for (let value of selectedItems2)
            //            selectedItems2.forEach(function (value: Stock.StockItemRow) {
            //                var PrdId = value.ProductId;
            //                var bomdetails = [];
            //                var labordetail = [];
            //                var PrdDetails = OMS.ProductMasterRow.getLookup().itemById[PrdId];


            //                // #region Product Attributes
            //                // **** Load & assign Attributes of Product using AtbID ****
            //                let ATBDetails = OMS.CommonAttributesRow.getLookup().itemById[PrdDetails.AttributeId]
            //                var BaseItm = ATBDetails.ProductTypeId;
            //                var ItemTypeId = ATBDetails.ItemTypeId;
            //                var Type = ATBDetails.CategoryName;
            //                var CategoryId = ATBDetails.CategoryId;
            //                var SubType = ATBDetails.SubCategoryName;
            //                var SubCategoryId = ATBDetails.SubCategoryId;
            //                var Brand = ATBDetails.BrandName;
            //                var BrandId = ATBDetails.BrandId;
            //                var SuperType = ATBDetails.SuperTypeName;
            //                var SuperTypeId = ATBDetails.SuperTypeId;
            //                var Collection = ATBDetails.CollectionName;
            //                var CollectionId = ATBDetails.CollectionId;
            //                var CalcOn = PrdDetails.CalcOnId;

            //                // #region Rate, Tax , SKU & Labor 
            //                var Rate = 0;
            //                var LaborRate = 0;

            //                // **** Get SKU for Item ****
            //                if (genSKU == true) {
            //                    var SKU = FormatHelper.GetFormat("Sku", "HO");
            //                }

            //                // #endregion

            //                var MaterialOutitem: Sales.MaterialOutItemsRow = {
            //                    ProductId: PrdId,
            //                    AttributeId: value.AttributeId,
            //                    Attribute: value.Attribute,
            //                    //Line_No: Sales.MaterialEditorForJobWork.LineNo,
            //                    VoucherTypeId: value.VoucherTypeId,
            //                    PartyId: self.PartyId,
            //                    SKU: "0",
            //                    DepartmentId: value.DepartmentId,
            //                    DeptName: value.DeptName,
            //                    ProductCode: value.ProductCode,
            //                    ProductName: value.ProductName,
            //                    ItemTypeId: ItemTypeId,
            //                    CategoryId: CategoryId,
            //                    ProductTypeId: BaseItm,
            //                    ProductTypeName: ATBDetails.ProductTypeName,
            //                    SubCategoryId: SubCategoryId,
            //                    BrandId: BrandId,
            //                    SuperTypeId: SuperTypeId,
            //                    CollectionId: CollectionId,
            //                    UnitRate: Rate,
            //                    UnitLabour: LaborRate,
            //                    Pieces: value.Pieces,
            //                    Weight: value.Weight,
            //                    OtherPieces: value.OtherPieces,
            //                    OtherWeight: value.OtherWeight,
            //                    StonePieces: value.StonePieces,
            //                    StoneWeight: value.StoneWeight,
            //                    NetWeight: value.NetWeight,
            //                    NetAmount: (Rate + LaborRate) * 1,
            //                    GrossAmount: (Rate + LaborRate) * 1,
            //                    DiamondPieces: value.DiamondPieces,
            //                    DiamondWeight: value.DiamondWeight,
            //                    CalcOnId: CalcOn,
            //                    BOMDetails: bomdetails,
            //                    // LaborDetails: labordetail,
            //                    CompanyId: companyId,

            //                    HSN: value.HSN,
            //                    KaratId: ATBDetails.KaratId,
            //                    MetalColorId: ATBDetails.MetalColorId,
            //                    QualityId: ATBDetails.QualityId,
            //                    SieveId: ATBDetails.SieveId,
            //                    ShapeId: ATBDetails.ShapeId,
            //                    RefTransId: value.TransId,
            //                    StoneColorId: ATBDetails.StoneColorId,
            //                    StoneSizeId: ATBDetails.StoneSizeId,
            //                    Purity: value.Purity == undefined ? 0 : value.Purity,
            //                    TaxCode: value.TaxCode
            //                };
            //                details.push(MaterialOutitem);



            //            });
            //            for (let Detail of details) {
            //                Detail[this.getIdProperty()] = "`" + this.nextId++;
            //                this.view.addItem(Detail);
            //            }

            //        }
            //        // #endregion

            //        pickerDialog.dialogOpen();
            //    }
            //});

            buttons.push({
                title: "Select Materials",
                cssClass: "order-button",
                hotkey: "alt+p",
                hint: 'alt+p',
                onClick: () => {
                    var self = this;
                    var master = (this.parentDialog as any);
                    var bagno = (this.parentDialog as any).form.BagNo.value;
                    if (bagno == "" || bagno == undefined) {
                        q.Alert("View Mode", "Work Order needs to be selected", 2000, false);
                        return;
                    }
                    var grid = Common.WorkOrderStockSelectGrid; 
                    var filters: _Ext.SelectGridFilters = {
                        BagNo: bagno,
                        FilterItems: ItemSelection.MS
                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters, Width: 800, height: 500
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var details = [];
                        var deptid = master.form.DepartmentId.value;
                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Stock.StockItemRow) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            

                            var lineno = parseInt((self.parentDialog as any).form.Line_No.value);
                             
                            var item: Sales.MaterialOutItemsRow = {
                                ProductId: PrdId,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ItemTypeId: value.ItemTypeId,
                                AttributeId: AtbId,
                                Line_No: value.Line_No,
                                SKU: value.SKU,
                                HSN: value.HSN,
                                CertificateNo: value.CertificateNo,
                                BagNo: bagno,
                                CalcOnId: value.CalcOnId,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                NetWeight: 0,
                                RefTransId: value.TransId,
                                Purity: value.Purity,
                                PureWeight: value.PureWeight,
                                RefTransItemId: value.TransItemId == null? 0 : value.TransItemId,
                                RefVoucherId: value.VoucherTypeId == null ? 0 : value.VoucherTypeId,
                                Attribute: value.Attribute,
                                KaratId: value.KaratId,
                                MetalColorId: value.MetalColorId,
                                ProductTypeId: value.ProductTypeId,
                                LotNo: value.LotNo,
                                Lab: value.Lab,
                                DeptName: value.DeptName,
                                VoucherTypeId: 39,

                            };

                            details.push(item);

                        });

                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion


                    }


                    pickerDialog.dialogOpen();
                }
            });

            //var btnAdd = Q.first(buttons, x => x.cssClass == "add-button");

            //btnAdd.onClick = e => { this.addButtonClick(); };

            return buttons;
        }



        // #endregion

    }
}